import { useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

export type TeamsSortOption = "totalKpi" | "avgKpi" | "avgPlayerKpi" | "avgGoalieKpi";
export type SortDirection = "asc" | "desc";

interface TeamsSortProps {
    onSortChange: (sortOption: TeamsSortOption, direction: SortDirection) => void;
}

const sortItems = [
    { value: "avgKpi" as TeamsSortOption, label: "Avg KPI", shortLabel: "Avg" },
    { value: "totalKpi" as TeamsSortOption, label: "Total KPI", shortLabel: "Total" },
    { value: "avgPlayerKpi" as TeamsSortOption, label: "Avg Player KPI", shortLabel: "Players" },
    { value: "avgGoalieKpi" as TeamsSortOption, label: "Avg Goalie KPI", shortLabel: "Goalies" },
];

export function TeamsSort({ onSortChange }: TeamsSortProps) {
    const [activeSort, setActiveSort] = useState<TeamsSortOption>("avgKpi");
    const [sortDirection, setSortDirection] = useState<SortDirection>("desc");

    const handleSortClick = (sortOption: TeamsSortOption) => {
        if (activeSort === sortOption) {
            const newDirection = sortDirection === "desc" ? "asc" : "desc";
            setSortDirection(newDirection);
            onSortChange(sortOption, newDirection);
        } else {
            setActiveSort(sortOption);
            setSortDirection("desc");
            onSortChange(sortOption, "desc");
        }
    };

    return (
        <nav id="onboarding-teams-sort" className="rounded-md p-1 mb-3 bg-surface-container-low">
            <div className="grid grid-cols-2 gap-1 md:flex md:items-center md:space-x-2 md:gap-0">
                {sortItems.map((item) => {
                    const isActive = activeSort === item.value;
                    return (
                        <button
                            key={item.value}
                            type="button"
                            className={`nav-tab ${isActive ? "nav-tab-active" : "nav-tab-inactive"}`}
                            onClick={() => handleSortClick(item.value)}
                        >
                            <div className="flex gap-1.5 items-center justify-center">
                                <span className="md:hidden">{item.shortLabel}</span>
                                <span className="hidden md:inline">{item.label}</span>
                                {isActive && (
                                    <span>
                                        {sortDirection === "asc" ? (
                                            <ArrowUp
                                                className="h-3.5 w-3.5"
                                                style={{ color: "var(--color-general-red)" }}
                                            />
                                        ) : (
                                            <ArrowDown
                                                className="h-3.5 w-3.5"
                                                style={{ color: "var(--color-general-green)" }}
                                            />
                                        )}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
